const en = {
  accept: "Accept",
  accessPermissionRequest: "Access permission request",
  accountBalance: "Account balance",
  accountDetails: "Current account details",
  accountType: "Account type",
  action: "Action",
  actionOptions: {
    toServer: "To server",
    visit: "Visit",
    maintenance: "Maintenance",
    bringsOrTakesServer: "Brings / takes a server",
    troubleshooting: "Troubleshooting"
  },
  actions: "Actions",
  active: "Active",
  activeContracts: "Active contracts",
  activeErrorTickets: "Active error tickets",
  actual: "Actual",
  actualNotifications: "Actual notifications",
  add: "Add",
  addAnotherContactPerson: "Add another contact person",
  addAnotherEntryPerson: "Add another entry person",
  addNewRow: "Add new row",
  addNewVm: "Add new VM",
  addToList: "Add to list",
  addedToDownloadList: "Added to download list.",
  address: "Address",
  admin: "Admin",
  administration: "Administration",
  administrationSynonym: "Administration",
  afType: "AF type",
  affectedServices: "Affected services",
  affectedSite: "Affected site",
  affectedSites: "Affected sites",
  aggregateMode: "Aggregate mode",
  agree: "I agree",
  all: "All",
  allBills: "All bills",
  allErrorTickets: "All error ticket",
  allServices: "All services",
  allowService: "Allow service",
  amount: "Amount",
  another: "More",
  apiErrorMessages: {
    "maintenance/maintenances/*": "There was an error during the load of the maintenances!",
    "maintenance/service_types": "There was an error during the load of the maintenance types!",
    "maintenance/accept": "There was an error during the acceptance of the maintenance!",
    "maintenance/reject": "There was an error during the rejection of the maintenance!",
    "maintenance/contactId/*": "There was an error during the load of the contact id!",
    "service/*": "There was an error during the load of the service!",
    "company/internalContacts/*": "There was an error during the load of the contacts!",
    "ticket/*/contactList": "There was an error during the load of the contacts!",
    "service/all/*": "There was an error during the load of the services!",
    "colosite/colo/*": "There was an error during the download of the server rooms!",
    "colosite/role": "There was an error during the download of the roles!",
    "colosite/service/*": "There was an error during the download of the services!",
    "colosite/vitrinService/*": "There was an error during the download of the services!",
    "colosite/user/*": "There was an error during the download of the users!",
    "ticket/*/ticket/list": "There was an error during the load of the error tickets!",
    "dms/casetype/list/service": "There was an error during the load of the cases!",
    "dms/cases/*": "There was an error during the load of the cases!",
    "dms/casetemplate/*": "There was an error during the load of the cases fields!",
    "dcma/access/*": "There was an error during the load of the server room accesses!",
    "dcma/access": "There was an error during the save of the server room access permit!",
    "contract/list/*": "There was an error during the load of the contracts!",
    "contract/contract/*": "There was an error during the load of the contract details!",
    "contract/services/*": "There was an error during the load of the contract related services!",
    "contract/documents/list/*": "There was an error during the load of the contract documents!",
    "contact/edit/selectorlist/*": "An error occurred while loading the selector list!",
    "contact/contactperson/new/*": "An error occurred while loading the new user's data!",
    "contact/contactperson/*": "An error occurred while loading the user's data!",
    "contact/contactperson": "An error occurred while saving the user's data!",
    "ticket/*/serviceId/openTicket/list": "There was an error during the load of the open error tickets!",
    "service/IMPLEMENT/*": "There was an error during the load of the establishments!",
    "ticket/errormessage/*": "There was an error during the loading!",
    "ticket/*/saveTicket/": "An error occurred while submitting the ticket!"
  },
  applicationGroups: "Application groups",
  applicationTraffic: "Application traffic",
  applyChanges: "Apply changes",
  attachFiles: "Attach files",
  attachedMessage: "Attached message: ",
  authorizedPerson: "Authorized person",
  average: "Average",
  back: "Back",
  backToMainPage: "Back to the main page",
  balance: "Balance",
  balanceAndCurrentBills: "Balance and current bills",
  bandwidthDown: "Bandwidth (down)",
  bandwidthUp: "Bandwidth (up)",
  bankAccount: "Bank account",
  barchart: "Barchart",
  beginning: "Beginning",
  billCollectorId: "Bill collector Id",
  billId: "Bill ID",
  billNumber: "Bill number",
  billTotal: "Bill total",
  billTypes: {
    bills: "Bill",
    adatkozlo: "Informant",
    calllog: "Call log",
    demandletter: "Letter of demand"
  },
  billing: "Billing",
  billingAddress: "Billing address",
  billingDate: "Billing date",
  bills: "Bills",
  billsOlderThanTwoYears: "Regarding your account that is over 2 years old, please contact corporate customer support on the toll-free number 1420 or by email at corporate@one.hu.",
  buildingVmBottomText: "The process may take several minutes, please be patient!",
  buildingVmCreateTitle: "Creating in progress",
  buildingVmList: [
    "Placing CPUs...",
    "RAM reservation...",
    "Insert storage...",
    "IP reservation...",
    "Domain registration...",
    "Operating system installation..."
  ],
  buildingVmModifyTitle: "Modification in progress",
  cancel: "Cancel",
  cannotBeEmpty: "Cannot be empty!",
  cardList: "Card list",
  cartCommentTxt: "Here you can let us know your comments and requests regarding your order.",
  cartContent: "Cart content",
  caseId: "Case Id",
  caseSendError: "Failed to send case",
  caseStartDate: "Case start date",
  caseType: "Case type",
  caseUnderRegistration: "Cases under registration",
  category: "Category",
  changeLanguage: "Váltás magyar nyelvre",
  changePassword: "Change Password",
  changePhoto: "Change photo",
  choose: "Choose",
  chooseCustomerFirst: "Choose a customer first",
  choosePlease: "Please select!",
  choosePreferredPayment: "Choose your preferred payment method",
  chooseRoutersFirst: "Choose routers first",
  chooseSitesFirst: "Choose sites first",
  classicAccount: "Classic account",
  clientCode: "Customer code",
  clipboardCopySuccessful: "Clipboard copy successful",
  close: "Close",
  closedCases: "Closed case",
  cloud: "Cloud",
  colleagueQuestion: "A colleague of their company or institution?",
  comment: "Comment",
  companyDetails: "Company details",
  companyInformation: "Company information",
  companyInformationSectionTxt: "By entering your tax number, we identify additional parameters of your company",
  companyName: "Company name",
  companySelectionError: "An error occurred while selecting the company!",
  companySelector: "Company Selector",
  companySelectorTitle: "Please choose from the list below which company you would like to act on behalf of!",
  completeSolutions: "Complete solutions",
  configurator: "Configurator",
  configureMfa: "Configure Two-step authentication",
  configureMfaDialog: "If you activate two-factor authentication on our website, please note that this setting can only be deactivated later by contacting corporate customer support (1420).",
  configureMfaDialogTitle: "Important Security Information",
  configureMfaExperimentalFeature: "Experimental Feature",
  confirm: "Confirm",
  confirmDelete: "Are you sure you want to delete?",
  confirmDeleteVm: "Are you sure you want to delete the virtual machine?",
  confirmVmName: "Please confirm the name of the virtual machine by typing the name below: ",
  consolePrivilege: "Console privilege",
  contact: "Contact",
  contactAdditionForVm: "A request has been made for $_{name} service id. ",
  contactData: "Contact data",
  contactHeader: "Please select the subject of the contact and write the message. We will contact you after processing your report!",
  contactHeaderVm: "Please write your needs for the selected virtual server. We will contact you after processing your request!",
  contactListLoadError: "There was an error during the load of the contacts!",
  contactMessageError: "There is an error during the process! Please, try again later!",
  contactMsgPlaceholder: "Please write your message here (max. 2000 characters) ...",
  contactPerson: "Contact person",
  contactSuccess: "Thank you for your contact!",
  contacts: "contacts",
  contractDetails: "Contract details",
  contractId: "Contract ID",
  contractNumber: "Contract number",
  contractTitle: {
    proposal: "Suspended establishment contracts",
    implement: "Contracts under construction",
    operating: "Active contracts"
  },
  contractingCompany: "Name of contracting company",
  contracts: "Contracts",
  contractsUnderConstruction: "Contracts under construction",
  contractualCurrentAccountNumber: "Contractual current account number",
  cookie: {
    allCookies: "Accept all cookies",
    cookieURL: "Learn more about cookies in our information sheet. ",
    headerMessage: "This website uses cookies",
    mainContentPart1: "This site uses cookies that are essential for its operation and to provide a better browsing experience, personalize content and analyze traffic. Cookies are primarily used by the website operator, and cookies necessary for traffic analysis are used by a third party (e.g. Google). ",
    mainContentPart2: "By accepting cookies, you consent to the use of required cookies.",
    requiredCookies: "I only accept required cookies"
  },
  copyErrorMessage: "Copy error message",
  couldNotDownloadFile: "Could not download file",
  cp: "Customer Portal",
  createNewVm: "Create new VM",
  creditCard: "Credit card",
  cssp: "Cloud Self Service Portal",
  csspDesc: "Cloud Self Service Portal",
  currency: "Currency",
  currentMaintenances: "Current maintenances",
  custom: "Custom",
  customer: "Customer",
  customerInfo: "Customer information",
  customerNameAddress: "Customer name, address",
  customerRegistrationNumber: "Customer registration number",
  dashboard: "Dashboard",
  dataCenter: "Data center",
  dataChange: "Data change report",
  dataChangeUser: "Change my data",
  dataTransfer: "Data transfer",
  datatable: "Datatable",
  date: "Date",
  datePickers: {
    locale: "en",
    helperText: "yyyy.mm.dd",
    timeHelperText: "yyyy.mm.dd hh:mm"
  },
  day: "Day",
  dcArduinoMeter: "DC Arduino Meters",
  dcArduinoMeterDesc: "You can track the consumption of your devices located in our data center",
  ddosSecurityService: "DDOS security",
  ddosSecurityServiceDesc: "View DDOS Services and Alerts",
  debtDueAfter8Days: "Debt due after 8 days",
  debtDueWithin8Days: "Debt due within 8 days",
  default: "Default",
  delete: "Delete",
  deleteConfirm: "Confirm delete",
  deleteContactCustomerService: "To delete, please contact our customer service",
  deleteContactMsg: "If you would like to delete a contact, please contact corporate customer support at the toll-free number 1420 or by email at corporate@one.hu.",
  deleteFilters: "Delete filters",
  deleteUserMsg: "If you would like to delete a user, please contact corporate customer support at the toll-free number 1420 or at the e-mail address corporate@one.hu.",
  description: "Description",
  details: "Details",
  dialog: "Dialog",
  disabledImpersonate: "Unable to use due to impersonation",
  dnsManagement: "DNS management",
  dnsManagementDesc: "DNS Zone management",
  documentNumber: "Document number",
  documentType: "Document type",
  domain: "Domain",
  domainCounterLoadError: "There was an error during the load of the domain counter!",
  domainExistsError: "An error occurred while checking the domain!",
  domainIncorrectEntry: "Incorrect entry.",
  domainListLoadError: "There was an error during the load of the domain list!",
  domainName: "Domain name",
  domainReserved: "Already reserved domain.",
  dontJudge: "Don't judge, it's a work in progress",
  downloadableDocuments: "Downloadable documents",
  drivingLicense: "Driving license",
  duration: "Duration",
  eBill: "E-bill",
  eNotice: "E-notice",
  eOrder: "E-order",
  eOrderSend: "E-order send",
  eOrderSendError: "Failed to submit an e-order",
  edit: "Edit",
  editSynon: "Edit",
  editUser: "Edit user",
  email: "E-mail",
  emailAddress: "E-mail address",
  emailAddressType: "E-mail address type",
  emptyCartHint: "Cart is empty!",
  emptyVmEdit: "No virtual machine selected to modify!",
  endDate: "End date",
  endpointAddress: "Endpoint address",
  enterCompanyTaxNumber: "Enter your company tax number",
  enterDate: "Enter date",
  enterDetails: "Enter details",
  enterInterval: "Enter interval",
  enterIntervalTooltip: "Single entry: each entry must be requested separately!",
  entityName: "Entity Name",
  entryInfo: "Entry info",
  error: "Error",
  errorButtonInProgress: "There is an ongoing error ticket on the service. No new errors can be submitted until the current ticket is resolved.",
  errorButtonLimited: "The error ticket cannot be started for a limited service.",
  errorButtonSuspend: "The error ticket cannot be started for a suspended service.",
  errorDetails: "Error details",
  errorMessage: "Error message",
  errorMessages: {
    companyListError: "There was an error during the load of the companies!",
    loadNotificationListError: "The notification list could not be loaded",
    notificationCounterLoadError: "There was an error during the load of the notification counter!",
    selectedCompanyLoadError: "There was an error during the load of the selected company!",
    establishmentCounterLoadError: "There was an error during the load of the establishment counter!",
    establishmentDataLoadError: "There was an error during the load of the establishments!",
    userDataLoadError: "There was an error during the load of the users!",
    billListLoadError: "There was an error during the load of the bills!",
    billTypesLoadError: "There was an error during the load of the bill types!",
    contractsListLoadError: "There was an error during the load of the contracts!",
    typesLoadError: "There was an error during the load of the types!",
    optionsLoadError: "There was an error during the load of the options!",
    serviceListLoadError: "There was an error during the load of the services!",
    contractDocumentDownloadError: "There was an error during the download of the contract document!",
    loadingError: "An error occurred while loading the data!",
    saveError: "There was an error during the save!",
    acceptError: "An error occurred during acceptance!",
    rejectError: "An error occurred during rejection"
  },
  errorTicket: "Error ticket",
  errorTicketDetails: "Detailed description of error ticket",
  errorTicketId: "Error ticket id",
  errorTicketListTitle: "In the list below, we list the service types for which a error ticket can be submitted",
  errorTicketOpenService: "There is an error ticket on the service",
  errorTicketRecording: "Error ticket recording",
  errorTicketSend: "Error ticket send",
  errorTicketSendError: "Failed to submit an error ticket",
  errorTicketSender: "Sender of error ticket",
  errorTooltipMessage: "Please provide all the necessary data regarding the service and the error phenomenon in order to accurately define and eliminate the error! If you do not provide enough information, our colleagues will contact you via one of the contact channels provided, so that we can start investigating the error as soon as possible. Ex: Data connection/internet service: What exactly are you experiencing? Totally out of service? Are the devices powered on, have they been restarted, do they seem operational? From where and what exactly are you unable to reach (in case of L3 service, IP address)? If there is a backup line, does it work? Voice/telephone service: What exactly do you experience? Is the line completely silent? Which number is affected by the error? Example call: number, called number, time of call, error phenomenon. In the case of an IP/internet-based telephone service, is the carrier service operating?",
  errorType: "Error type",
  establishments: "Establishments",
  euCommunityTaxNumber: "Eu community tax number",
  exhibitionMethod: "Exhibition method",
  expectedConstruction: "Expected construction",
  expirationDate: "Date of expiration",
  expirationDateError: "An error occurred while loading the expiration date!",
  expiredNotifications: "Expired notifications",
  exportToExcel: "Export to Excel file",
  fastlane: "Fastlane",
  fastlaneDesc: "Kubernetes Fastlane",
  favouriteFood: "Favourite food",
  feedbackDeadline: "Feedback deadline",
  fees: "Fees",
  fileError: "Bad file",
  fileErrorSize: "Maximum file size is 20 MB",
  fileErrorType: "Invalid file type. Suitable types: ",
  fileNotFound: "File not found",
  fileUploadTooltip: "Maximum size: 20 MB. Supported file types: ",
  filter: "Filter",
  filterChanged: "The filters have changed, click to update the data",
  filters: "Filters",
  financialContact: "Customer Portal - Financial Contact",
  financialPartner: "Financial partner",
  finishedMaintenances: "Finished maintenances",
  firmwareVersion: "Firmware version",
  firstName: "First name",
  footer: {
    mainPage: {
      mainPageText1: "PERSONALIZED SOLUTIONS. EXACTLY THE WAY YOU WANT.",
      askForOffer: "Ask for offer now!",
      aboutUs: "About us",
      solutions: "Solutions",
      socialMedia: "Social media",
      aboutOne: "About One Solutions",
      references: "References",
      career: "Career",
      socialResponsibility: "Social responsibility",
      centralizedProcurement: "Centralized procurement",
      smartVillage: "Smart village",
      forLargeCompanies: "For large companies",
      forSmallAndMediumCompanies: "For small and medium companies",
      forInstitutions: "For institutions",
      forWholesalers: "For wholesalers",
      businessServices: "Business services",
      infrastructureServices: "Infrastructure services",
      news: "News",
      press: "Press",
      blog: "Blog",
      loginToCustomerPortal: "Login to the customer portal",
      loginToTechnicalPortal: "Login to the technical portal",
      loginToCSSP: "Login to the Cloud Self Service Portal"
    },
    dataProtection: "Data protection",
    dataProcessingCode: "Data processing code",
    termsAndConditions: "Terms and Conditions",
    gtc: "GTC",
    certificates: "Certificates",
    impress: "Impress",
    providerInformation: "Provider information",
    filteringSoftware: "Filtering Software",
    coServiceOffers: "Co-service offers",
    premiumServices: "Premium services",
    iivrApplication: "IIVR Application"
  },
  forms: "Forms",
  from: "from",
  fromDate: "From date",
  fulfillmentDate: "Fulfillment date",
  generalSearch: "General Search",
  gift: "gift",
  hardwareDeliveryPrivilege: "Hardware delivery privilege",
  hardwareExchangePrivilege: "Hardware exchange privilege",
  hasDuplicateDomainHint: "The specified domain name is listed more than once!",
  headquarters: "Headquarters",
  help: "Help",
  home: "Home",
  homePage: {
    mainTitle: "Build your own scalable dedicated server or choose from the configurations below",
    mainList: [
      "Guaranteed troubleshooting within 4 hours",
      "The compiled configuration can be flexibly modified at any time",
      "Can be put into operation immediately",
      "Continuous backup and monitoring",
      "You can run your own operating system"
    ],
    additionalBenefits: "Additional benefits",
    additionalBenefitsCards: {
      card1Title: "Professional operation",
      card1Text: "Redundant infrastructure, Internet access provided by multiple core network data connections.",
      card2Title: "Cost-efficient",
      card2Text: "You can achieve a cost reduction of up to 15-30% compared to running your own physical server. Monthly subscription based service.",
      card3Title: "Safe",
      card3Text: "Our machine rooms meet the highest security standards, and the data stored on our servers will always be secure.",
      card4Title: "Customizable",
      card4Text: "You don't need to scale your server for years to come, as you can increase it at any time to suit your operational and hardware needs."
    },
    selfCareTutorial: "Self Care tutorial",
    theyChoseUs: "They chose us",
    theyChoseUsDescription: "As an expert and experienced partner, we offer answers to a unique and complex business challenge based on your IT needs. Develop your IT system consciously and predictably, avoid one-time large investments, rent server services on a monthly fee basis."
  },
  hostname: "Hostname",
  hour: "Hour",
  huf: "HUF",
  ictSkill: 'ICT skill',
  id: "ID",
  idCard: "ID card",
  identificationNumber: "Identification number",
  ifName: "IF Name",
  inactive: "Inactive",
  inactiveErrorTickets: "Inactive error tickets",
  interfaceData: "Interface data",
  internet: "Internet",
  invalidEmailMsg: "Email address is invalid!",
  invalidPhoneNumberMsg: "Phone number is invalid!",
  invitation: "Invitation",
  invitationError: "An error occurred while sending the email(s)!",
  invitationSenderText: "Please specify who you want to send an invitation to!",
  invitationSuccess: "Successfully sent email(s)!",
  invitech: "One Solutions",
  invitechContacts: "One Solutions contacts",
  invoiceOutputTypes: {
    REMOTE: "remote",
    PAPER: "paper",
    ELECTRO: "electronic"
  },
  invoicingAdministration: "Invoicing administration",
  ipAddress: "IP Address",
  itPartner: "IT partner",
  itSolutions: "IT solutions",
  jitter: "Jitter",
  lastData: "Last data",
  lastName: "Last name",
  lastUpdate: "Last update",
  lateFeeInfoUnavailable: "Due to technical reasons, information regarding late payment charges is temporarily unavailable on the Customer Portal interface. You can inquire about the total amount payable, including late payment charges, through our other customer service channels.",
  latency: "Latency",
  later: "Later",
  legalText: {
    prices: "Prices are in HUF and do not include VAT.",
    checkBoxPrimary: "Please check the box to confirm that you have read understood and accepted our ",
    checkBoxFirstConjunction: " and ",
    checkBoxSecondConjunction: ".*"
  },
  level: "Level",
  licensePlate: "License plate number",
  licenseType: "License type",
  linechart: "Linechart",
  loadingCompanyData: "Loading company data",
  loadingList: "Loading list",
  loggedInContact: "Logged in contact",
  loggingIn: "Logging in...",
  login: "Login",
  loginAndLogout: "Login / logout",
  logout: "Log Out",
  logoutDialogContent: "Please log in again to apply the changes.",
  macAddress: "MAC address",
  mailText: "The email address is the same as the username",
  maintenance: "Maintenance",
  maintenanceRejectionConfirm: "Are you sure you want to reject the maintenance below?",
  maintenanceType: "Maintenance type",
  maintenances: "Maintenances",
  managerContact: "Manager contact",
  manual: "Manual",
  map: "Map",
  masterData: "Master data",
  masterDataChangeWarning: "Master data is provided for the following customers:\n$_{companyList}.\nIn the event of a change, it will also change for the customers listed here.",
  max: "Max",
  message: "Message",
  messageSubject: "Message subject",
  mfaDialogContent: {
    text: "To use the DNS Self-Service Module, you must accept the following:",
    firstPoint: "(i) I acknowledge and accept that the use of the Module is only possible with two-factor authentication (enabling it is mandatory)!",
    secondPoint: {
      title: "(ii) I declare that I am aware of the risks associated with DNS settings and I acknowledge that the Service Provider is not responsible for any malfunctions resulting from incorrect settings!",
      text: "In the Module, the administration of public internet domain names associated with and linked to registered subscribers can be performed. This includes the creation, deletion, and modification of DNS records. Subscribers are unable to add new zones or delete existing ones; this is performed by the service provider. The system performs basic, primarily syntactical checks and provides feedback on these. Problems arising from possibly incorrectly performed operations – which can include, among other things, the unavailability of a website associated with a domain name or the cessation of email correspondence related to the domain name – fall under the subscriber's responsibility.",
      errorContactPrefix: "\n(In case of an error, the service provider can be contacted at ",
      errorContactSuffix: " email address for assistance.)"
    }
  },
  min: "Min",
  minimum3CharactersRequired: "At least three characters are required to begin searching",
  missingInput: "Missing input field",
  mobile: "Mobile",
  mobileContactType: "Mobile contact type",
  mobileNumber: "Mobile number",
  month: "Month",
  muiDataTableLocalization: {
    body: {noMatch: "No matching records founds", toolTip: "Sort"},
    pagination: {
      next: "Next page",
      previous: "Previous page",
      rowsPerPage: "Rows per page:",
      displayRows: "of"
    },
    toolbar: {
      search: "Search",
      downloadCsv: "Export",
      print: "Print",
      viewColumns: "View columns",
      filterTable: "Filter table"
    },
    filter: {all: "All", title: "Filters", reset: "Reset"},
    viewColumns: {title: "Show columns", titleAria: "Show/Hide table Ccolumns"},
    selectedRows: {
      text: "row(s) selected",
      delete: "Delete",
      deleteAria: "Delete selected rows"
    }
  },
  myPermissions: "My permissions",
  myProfile: "My profile",
  name: "Name",
  nameSynonym: "Name",
  necessaryDocuments: "Necessary documents!",
  necessaryDocumentsTooltip: "The following document(s) are required to start a case!",
  needVmForConfigurator: "At least one virtual machine for the configurator to function",
  newContact: "New contact",
  newContactToward: "To add a new contact, go to the Server room permissions page!",
  newErrorReport: "New error report",
  newUser: "New user",
  newVersionAvailable: "New version available! Please, refresh!",
  next: "Next",
  no: "No",
  noAffectedServiceSelected: "No affected service is selected!",
  noChangesInVm: "There are no modifications present for the virtual machine",
  noDataToDisplay: "No data to display!",
  noDataWithGivenFilters: "There is no available data with the given filters",
  noMaintenance: "No maintenance is currently in progress",
  noMessageSubjectSelected: "No message subject selected!",
  noPageView: "You do not have the appropriate permissions to view this page!",
  noPayableBill: "There is no bill to pay!",
  noPermission: "You do not have the appropriate permissions!",
  noService: "No service",
  noTaxNumber: "No tax number specified",
  notFoundLabel: "Page not found",
  notFoundSubLabel: "You may have misplaced or the page you were looking for has disappeared in the meantime. Check the URL or select from the menu to continue.",
  notSelected: "Not selected",
  notice: "Notice",
  notifications: "Notifications",
  object: "Object",
  offers: "Offers",
  onSiteContact: "On-site contact",
  onSiteContactEmail: "On-site contact e-mail",
  onSiteContactName: "On-site contact name",
  onSiteContactPhoneNumber: "On-site contact phone number",
  operatingSystem: "Operating system",
  operatingSystemShort: "Op. system",
  operationCannotBeUndone: "The operation cannot be undone!",
  operativePartner: "Operative partner",
  optionalOpSystem: "Optional op. system",
  order: "Order",
  orderLoadError: "There was an error during the load of the order!",
  orderSaveError: "There was an error during the save of the order!",
  osListLoadError: "There was an error during the load of the operating systems!",
  other: "Other",
  otherServiceParameters: "Other service parameters",
  overdueDebt: "Overdue debt",
  overviewOfEstablishments: "Overview of establishments",
  overviewOrderProducts: "Overview of products to order",
  packetLoss: "Packet loss",
  pageNotFound: "Page not found",
  pageNotFoundLong: "Sorry, we couldn't found the page you are looking for.",
  paid: "Paid",
  paperBase: "Paper base",
  passport: "Passport",
  payable: "Payable",
  paymentDate: "Payment date",
  paymentDeadline: "Payment deadline",
  paymentDetails: "Payment details",
  paymentMethod: "Payment method",
  pendingCases: "Pending cases",
  percentage: "Percentage",
  performanceMonitor: "Performance monitor",
  performanceMonitorDesc: "A tool that displays performance graphs of network and other devices",
  period: "Period",
  periodEnd: "End of period:",
  permissionDenied: "Access denied",
  permissionDeniedMsg: "You have no access to this page. Please go back to the home page.",
  permissionPrivilege: "Permission privilege",
  personalData: "Personal data",
  phone: "Phone",
  phoneNumber: "Phone number",
  phoneNumberHelperTxt: "+<country code> <area> <phone number>",
  phoneNumberType: "Phone number type",
  pleaseWait: "Please wait...",
  plotlyLocale: {locale: "en"},
  portId: "Port id",
  portalAccess: "Portal access",
  position: "Position",
  positions: {
    ceo: "CEO",
    cio: "CIO",
    cto: "CTO",
    ciso: "CISO",
    cfo: "CFO",
    staff: "Staff"
  },
  post: "Post",
  previousMaintenance: "Previous maintenance",
  privacyPolicy: "Privacy policy",
  privilegeLevels: "Privilege levels",
  privilegeLevelsLocalization: {
    admin: "Has full authority.",
    all: "All users have access to the menu items \"Support\", \"Notifications\", \"Company data\", their \"User profile\" and our news.",
    consolePrivilege: "You can take over the Customer's server by remote access, but you cannot access it physically.",
    financialPartner: "Can manage their error reports, customer service cases, and view their services.",
    hardwareExchangePrivilege: "With console privilege, you have the right to request the server to a designated room and perform repair work. (This does not apply to a rented server owned by the Service Provider!)",
    hardwareDeliveryPrivilege: "You are entitled to take the device away, and you also have Console and Hardware exchange privilege. (This does not apply to a rented server owned by the Service Provider!)",
    itPartner: "Has access to all functions except user registration.",
    financialContact: "Can view billing and contract information, manage your customer service matters.",
    technicalContact: "Can manage their error reports, customer service cases, and view their services."
  },
  profile: "Profile",
  pushMe: "Push Me!",
  range: "Range",
  refresh: "Refresh",
  registeringCourt: "Registering court",
  registrationForFreeIceCream: "Registration for Free Ice Cream",
  registrationNumber: "Company registration number",
  reject: "Reject",
  rejectMaintenance: "Maintenance rejection",
  rejectReason: "Reject reason",
  relatedBills: "Related bills",
  relatedErrorTickets: "Related error tickets",
  relatedServices: "Related services",
  relatedServicesChange: "Linked service ID",
  relatedServicesID: "Related service ID",
  relatedSite: "Equipment address",
  remoteAccount: "Remote account",
  reportDate: "Report date",
  reportEndDate: "Closing date",
  reportedAsErrorTicket: "Reported as an error ticket",
  reporterName: "Reporter's name",
  requestForOffer: "Request for offer",
  requestForOfferInProgress: "Request for offer in progress",
  requiredPaymentDetails: "The company and payment details are also required to place an order",
  reservedDomainHint: "Already reserved or incorrect domain(s) specified!",
  rights: "Rights",
  role: "Role",
  roles: {
    admin: "Admin",
    finance: "Financial Contact",
    technical: "Technical Contact"
  },
  routerName: "Router name",
  routerSerialNumber: "Router serial number (S/N)",
  routerType: "Router type",
  save: "Save",
  scheduled: "Scheduled",
  scheduledLoginLogout: "Scheduled login and logout",
  sdWanDesc: "SD-WAN service overview interface",
  sdWanId: "SD-WAN id",
  sdwanSites: "SD-WAN Sites",
  selectObjects: "Select objects",
  send: "Send",
  sendInvitation: "Send Invitation",
  sendRequest: "Send request",
  sendRequestForOffer: "Send request for offer",
  senderDetails: "Sender details",
  serverName: "Server name",
  serverRoom: "Server room",
  serverRoomAccess: "Server room access",
  serverRoomAccessPermit: "Server room access permit",
  serverRoomAccesses: "Server room accesses",
  serverRoomPermissions: "Server room permissions",
  service: "Service",
  serviceAddress: "Service address",
  serviceAdministration: "Service administration",
  serviceCategories: {
    internet: "Data and internet services",
    dataCenter: "Data center services",
    other: "Other services",
    cloud: "Cloud services",
    office: "Office IT systems",
    security: "IT security services",
    communication: "Telephone and communication services"
  },
  serviceError: "Service error",
  serviceId: "Service id",
  serviceParameters: "Service parameters",
  serviceRelatedNotification: "Service related notification",
  serviceStatus: "Service status",
  serviceSynonym: "Service",
  serviceType: "Service type",
  services: "Services",
  setting: "Setting",
  settings: "Settings",
  shId: "SH identifier",
  showAllVms: "Show all VMs",
  showApplicationTraffic: "Show application traffic data",
  showCode: "Show me the code",
  showInterfaceData: "Show interface data",
  showLineBreaks: "Show line breaks",
  showSiteDetails: "Show site details",
  showTrafficData: "Show traffic data",
  signatureDate: "Signature date",
  site: "Site",
  siteAddress: "Site address",
  siteOrder: "Site order",
  sites: "Sites",
  soc: "SOCaaS",
  socDesc: "The Security Operations Center (SOC) service provides 24/7 monitoring and active security detection and management.",
  solution: {
    forGeneralBusinessUse: "for general business use",
    forHighComputingNeeds: "for high computing needs",
    forMediumComputingNeeds: "for medium computing needs",
    toHostLargeContent: "to host large content",
    customVmDescription: "custom configuration for individual needs"
  },
  solutionListLoadError: "There was an error during the load of the solutions!",
  solutions: "Solutions",
  sortByDate: "Sort by date",
  sound: "Sound",
  speedMbps: "Speed (MBPS)",
  ssoRolesTooltip: "Please contact our Customer Service regarding the registration of additional users.",
  starWarsMovies: "Star Wars movies",
  startDate: "Start date",
  startDateSynonym: "Start date",
  status: "Status",
  statusChangeDate: "Date of status change",
  statusError: "Status: Error",
  statusOk: "Status: OK",
  statusSynonym: "Status",
  statusUnknown: "Status: Unknown",
  statusWarning: "Status: Warning",
  storage: "Storage",
  storageType: "Storage type",
  storageTypeListLoadError: "There was an error during the load of the storage types!",
  successCaseStart: "Successful case starts",
  successCreate: "Successful creation",
  successDelete: "Successful delete",
  successEOrderSend: "Successful e-order",
  successEdit: "Successful modification",
  successErrorTicketSend: "Successful error ticket recording",
  successVmCreateTitle: "Successful VM creation",
  successVmDeleteTitle: "Successful VM delete",
  successVmEditTitle: "Successful VM modification",
  successfulAcceptance: "Successful acceptance",
  successfulEntry: "Successful entry",
  successfulModification: "Successful modification",
  successfulRejection: "Successful rejection",
  summary: "Summary",
  support: "Support",
  suspendedEstablishmentContracts: "Suspended establishment contracts",
  taxNumber: "Tax number",
  technicalBackground: "Technical background",
  technicalContact: "Customer Portal - Technical Contact",
  technicalId: "Technical ID",
  technicalOverview: "Technical overview",
  technical_support: "Support",
  testPeriod: "Test period",
  timeSelectorOptions: {s: "s", m: "m"},
  to: "to",
  toDate: "To date",
  tooLongName: "The name you entered is too long!",
  tooLongNote: "The note is too long!",
  tooManyVmAndReservedDomainHint: "You have reached the max. VM number ($_{count} pcs) and reserved or incorrect domain(s) specified!",
  tooManyVmHint: "You have reached the max. VM number ($_{count} pcs)!",
  total: "Total",
  totalDebt: "Total debt",
  tp: "Technical Portal",
  traffic: "Traffic",
  trafficData: "Traffic data",
  transfer: "Transfer",
  trialTimeExpire: "Test period end: ",
  tryIt: "Try it",
  type: "Type",
  underAssignment: "Under assignment",
  underConstruction: "Under construction",
  uniqueOffer: "unique offer",
  unknownAddress: "Unknown address",
  unknownError: "Unknown error",
  unpaidBills: "Unpaid bills",
  uploadFiles: "Upload files",
  user: "User",
  userData: "User data",
  users: "Users",
  usersAndPermissions: "Users and permissions",
  validity: "Validity",
  version: "Version",
  virtualMachine: "Virtual machine",
  virtualMachineChange: "Virtual machine changing",
  virtualMachineName: "Virtual machine's name",
  virtualMachineOrder: "Virtual machine ordering",
  virtualServer: "Virtual server",
  virtualServerDashboard: "Virtual server dashboard",
  virtualServerVm: "Virtual server (VM)",
  vmConfigurator: "VM Configurator",
  vmCounterLoadError: "There was an error during the load of the vm counter!",
  vmCreateInProgressText: "The requested operation is taking longer than average, so please be patient. We don't want to wait any longer, so feel free to close this window and we'll notify you via email as soon as we're done.",
  vmCreateInProgressTitle: "Creating VM in progress",
  vmDeleteError: "There was an error during the delete of the vm!",
  vmEditInProgressTitle: "Modify VM in progress",
  vmInProgressError: "Operation in progress!",
  vmListLoadError: "There was an error during the load of the vm list!",
  vmLoadError: "There was an error during the load of the vm!",
  vmNameChangeError: "An error occurred while changing the VM name!",
  vmNameChangeSuccess: "Successful VM name change",
  vmTemplateLoadError: "There was an error during the load of the vm details!",
  vmUpdateError: "There was an error during the update of the vm!",
  voice: "Voice",
  week: "Week",
  whichCompanyComeFromQuestion: "Which company do you come from?",
  workLog: "Work log",
  yes: "Yes"
};

export default en;
